var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"le-Tabs-container"},[_vm._l((_vm.list),function(item,idx){return _c('div',{key:idx,class:_vm.index==idx?'list-item active':'list-item',on:{"click":function($event){return _vm.tabItem(idx)}}},[_vm._v(_vm._s(item))])}),_c('a-range-picker',{staticStyle:{"width":"200px"},on:{"change":_vm.onChange}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }